module.exports = "<ng-content></ng-content>\r\n<div class=\"ic-card__content-action\">\r\n    <ng-content select=\"ic-navigation\"></ng-content>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/layout/card/card-content.component.html
// module id = ../../../../../src/app/layout/card/card-content.component.html
// module chunks = main